<template>
  <div class="search-heroes">
    <h1 class="search-heroes__title page-title">
      Search for Heroes
    </h1>

    <el-tabs v-model="activeSearchType" class="search-heroes__tabs">
      <el-tab-pane label="Search by name" name="name-search" lazy>
        <search-by-name
          @recieve-data="handleRecieveData"
          @reset-data="handleResetData"
          :skip="skip"
          :limit="limit"
          :event-id="eventId"
          ref="searchByName"
        />
      </el-tab-pane>
      <el-tab-pane label="Search by criteria" name="criteria-search" lazy>
        <search-by-criteria
          @recieve-data="handleRecieveData"
          :skip="skip"
          :limit="limit"
          :event-id="eventId"
          ref="searchByCriteria"
        />
      </el-tab-pane>
    </el-tabs>

    <search-result
      :hero-array="heroArray"
      :total="total"
      @update-data="handleUpdateSearchResult"
    />

    <el-pagination
      v-if="heroArray && heroArray.length > 0"
      layout="prev, pager, next"
      :total="total"
      hide-on-single-page
      :page-size="limit"
      :current-page="currentPage"
      @current-change="onNavigate"
    />
  </div>
</template>

<script>
import SearchByName from '@/components/searchEventParticipants/SearchByName.vue';
import SearchByCriteria from '@/components/searchEventParticipants/SearchByCriteria.vue';
import SearchResult from '@/components/searchEventParticipants/SearchResult.vue';

export default {
  name: 'SearchHeroes',
  components: {
    SearchByName,
    SearchByCriteria,
    SearchResult,
  },
  data() {
    return {
      activeSearchType: 'name-search',
      heroArray: null,
      total: null,
      limit: 20,
      currentPage: 1,
    };
  },
  computed: {
    skip() {
      const { currentPage, limit } = this;
      return (currentPage - 1) * limit;
    },
    eventId() {
      return Number(this.$route.query.eventId);
    },
  },
  methods: {
    handleRecieveData(data) {
      this.heroArray = data.items;
      this.total = data.totalCount;
    },
    onNavigate(nextPage) {
      this.currentPage = nextPage;
    },
    handleUpdateSearchResult() {
      const { activeSearchType } = this;
      if (activeSearchType === 'name-search') {
        if (this.$refs.searchByName) {
          this.$refs.searchByName.fetchParticipants();
        }
      } else {
        if (this.$refs.searchByCriteria) {
          this.$refs.searchByCriteria.updateSearchData();
        }
      }
    },
    handleResetData() {
      this.heroArray = null;
      this.total = null;
    },
  },
};
</script>

<style lang="scss">
.search-heroes {
  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-350);
    font-weight: normal;
    font-size: var(--font-size-800);
  }
  &__tabs {
    .el-tabs__item {
      font-size: var(--font-size-500);
      line-height: 1.6;
    }
    .el-tabs__header {
      margin-bottom: var(--global-dimension-size-350);
    }
  }
  &__results {
  }

  &__form {
    margin-bottom: var(--global-dimension-size-250);
  }

  &__buttons {
    text-align: right;
  }
}
</style>
